import { Injectable } from '@angular/core';
import { PreInitSettingsService, IPreInitAppSettings } from './settings/pre-init-setting.service';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AppSettingsService } from './app-settings.service';
import { PGHAppLoadService } from './pgh-app-load.service';
import { AppInsightsService } from './app-insights.service';

@Injectable({
  providedIn: 'root'
})
export class PreInitService {
  constructor(
    private preInitSettingsService: PreInitSettingsService,
    private appSettingsService: AppSettingsService,
    private appLoadService: PGHAppLoadService,
    private appInsightsService: AppInsightsService
  ) { }

  loadConfig(): Observable<any> {
    return this.appSettingsService
      .getPageJson<IPreInitAppSettings>('config/appSettings.json')
      .pipe(
        tap((config) => {
          window['logWithTime']('Initiailize app');
          this.appLoadService.initializeApplication();
          if (window.location.hostname === 'localhost' && config.middleWare) {
            const localApi: string = (window as any).Buildconfig?.localApi ?? '';
            config.middleWare.middlewareUrl = localApi.endsWith('/') ? localApi : localApi + '/';
            config.middleWare.accountPath = '';
          }
          // Apply brand-resolved Okta baseUrl/issuer (set earlier by index.html initOktaConfig)
          if ((window as any).pghconfig?.okta && config.okta) {
            config.okta.baseUrl = (window as any).pghconfig.okta.baseUrl ?? config.okta.baseUrl;
            config.okta.issuer = (window as any).pghconfig.okta.issuer ?? config.okta.issuer;
          }
          this.preInitSettingsService.setSettings(config);
          var settings = this.preInitSettingsService.getSettings();
          let insKey = settings?.applicationInsights?.instrumentationKey;
          if (insKey) {
            this.appInsightsService.loadAppInsightConfigs(insKey);
          }
        })
      );
  }
}
